import moment from 'moment'
import { type QuestionnaireSessionApiOutContract } from '@/api/generated/pwrdbyQuickMDAdminsApi.schemas'

type Props = {
  session?: QuestionnaireSessionApiOutContract | undefined
}

// Renders an online (async) visit's questionnaire answers as flat Question/Answer pairs, reusing the
// intake-questions page styling. Shown instead of the intake-form Questions view when the URL carries
// a sessionId.
export const QuestionnaireAnswers = ({ session }: Props) => {
  if (!session) return null

  const completedOn = session.CompleteDateTime ? moment(session.CompleteDateTime).format('MMM DD YYYY') : '--'

  return (
    <div className='intake-questions-table'>
      <div className='intake-questions-item-container'>
        <div className='intake-questions-question'>Completed on: {completedOn}</div>
      </div>
      <hr className='intake-questions-divider' />
      {(session.Answers ?? []).map((answer, index) => (
        // eslint-disable-next-line react/no-array-index-key -- questionnaire answers are a static, ordered list with no stable id
        <div className='intake-questions-item-container' key={`${answer.Question}-${index}`}>
          <div className='intake-questions-question'>{answer.Question}</div>
          <div className='intake-questions-answer'>{answer.Answer}</div>
        </div>
      ))}
    </div>
  )
}
